function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Veriforce_Logo");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.39,95.22,86,58.93a2,2,0,0,0-1.57-3.62L2,91.08v4.25A1.42,1.42,0,0,0,2.39,95.22Z",
  fill: "#00698f"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.39,86.93,86,50.64A2,2,0,0,0,84.4,47L2,82.79v4.26A1.45,1.45,0,0,0,2.39,86.93Z",
  fill: "#005487"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.4,103.44,86,67.15a2,2,0,0,0-1.57-3.62L2,99.3v4.25A1.65,1.65,0,0,0,2.4,103.44Z",
  fill: "#006e96"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.4,111.61,86,75.32A2,2,0,0,0,84.4,71.7L2,107.47v4.25A1.65,1.65,0,0,0,2.4,111.61Z",
  fill: "#0083ad"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.39,78.59,86,42.3a2,2,0,0,0-1.57-3.62L2,74.45v4.26A2.06,2.06,0,0,0,2.39,78.59Z",
  fill: "#004876"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.4,42.3a2,2,0,0,0,.78.16A2,2,0,0,0,86,38.68L2.39,2.39A1.42,1.42,0,0,0,2,2.28V6.53Z",
  fill: "#007853"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.4,75.32a2,2,0,0,0,2.59-1,2,2,0,0,0-1-2.59L2.39,35.41A1.42,1.42,0,0,0,2,35.3v4.25Z",
  fill: "#00b451"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.4,50.64a2,2,0,0,0,.78.17A2,2,0,0,0,86,47L2.39,10.74A2.06,2.06,0,0,0,2,10.62v4.26Z",
  fill: "#00c4b3"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.4,58.93a2,2,0,0,0,.78.16A2,2,0,0,0,86,55.31L2.39,19A1.42,1.42,0,0,0,2,18.91v4.25Z",
  fill: "#00acd8"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M84.4,67.15a2,2,0,0,0,.78.16A2,2,0,0,0,86,63.53L2.39,27.24A1.42,1.42,0,0,0,2,27.13v4.25Z",
  fill: "#76bc21"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M114.17,38.33h10.46l9,28.48,8.9-28.48h10.08l-13.5,38.3H127.67Z",
  fill: "#d9d8d6"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M230.82,32.83h-10.2V23.76h10.2Zm-10.2,5.5h10.2v38.3h-10.2Z",
  fill: "#d9d8d6"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240.18,45.69h-6.44V38.33h6.44c.08-1.11.08-2.23.16-3.27.38-7.81,4-11.82,12.65-11.82a36,36,0,0,1,5.45.44v7.51a14.58,14.58,0,0,0-3.38-.37c-4.06,0-4.75,2.09-4.75,7.51H258v7.36h-7.67V76.63H240.18Z",
  fill: "#d9d8d6"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M278.23,37.22c11.58,0,18.95,8.33,18.95,20.22,0,12-7.22,20.23-18.95,20.23s-19-8.18-19-20.23S266.57,37.22,278.23,37.22Zm-.08,32.72c5.83,0,9.13-5.06,9.13-12.5s-3.3-12.56-9.13-12.56c-5.68,0-9,5.13-9,12.49S272.4,69.94,278.15,69.94Z",
  fill: "#d9d8d6"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M362.68,62.2C361.38,72,355,77.82,345.27,77.82c-11.28,0-18.41-8.18-18.41-20s6.9-20.59,18.48-20.59c9.13,0,16.27,4.83,17.11,14.65h-9.51c-.54-4.39-3.3-6.92-7.37-6.92-6.13,0-8.74,5.73-8.74,12.86,0,6.7,2.68,12.27,8.44,12.27,4.37,0,7.21-3,7.9-7.88Z",
  fill: "#d9d8d6"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M162,60.08c.23,6.47,3.37,10.34,9.2,10.34,4,0,6.83-2.16,7.82-5.65h9.52C186.41,73.32,180,77.71,171,77.71c-11.74,0-18.87-8.11-18.87-20.23,0-11.82,7.67-20.15,18.72-20.15,11.73,0,17.78,8.51,18.16,20.19,0,1.29,0,1.73-.05,2.56Zm8.74-15.32c-5.45,0-8.28,4-8.67,8.63h17.53C178.93,47.74,175.59,44.76,170.76,44.76Z",
  fill: "#d9d8d6"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M375.18,60.08c.23,6.47,3.37,10.34,9.2,10.34a7.64,7.64,0,0,0,7.83-5.65h9.51c-2.15,8.55-8.51,12.94-17.57,12.94-11.73,0-18.87-8.11-18.87-20.23,0-11.82,7.68-20.15,18.72-20.15,11.74,0,17.78,8.51,18.16,20.19,0,1.29,0,1.73-.05,2.56Zm8.74-15.32c-5.44,0-8.28,4-8.66,8.63h17.53C392.1,47.74,388.76,44.76,383.92,44.76Z",
  fill: "#d9d8d6"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193,38.33h5.33l3.07,7.2c2.84-5.06,7-7.53,12.76-7.53a11.92,11.92,0,0,1,2.66.16v9.08a13.62,13.62,0,0,0-3.45-.45c-8.9,0-11.35,5.65-11.35,15.54v14.3h-9Z",
  fill: "#d9d8d6"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M301.52,38.33h5.34l3.06,7.2c2.84-5.06,7-7.53,12.76-7.53a11.92,11.92,0,0,1,2.66.16v9.08a13.62,13.62,0,0,0-3.45-.45c-8.9,0-11.35,5.65-11.35,15.54v14.3h-9Z",
  fill: "#d9d8d6"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M402.53,41.07a3.67,3.67,0,0,1,3.71-3.79,3.78,3.78,0,1,1-3.71,3.79Zm6.74,0a3,3,0,1,0-6,0,3,3,0,1,0,6,0Zm-4.35-2h1.4c1,0,1.42.56,1.42,1.21a1.11,1.11,0,0,1-.68,1.08c.19.39.54,1.15.73,1.54h-.73c-.17-.36-.47-1-.64-1.41h-.84v1.41h-.66Zm1.42,1.83a.67.67,0,0,0,.74-.64c0-.32-.19-.58-.77-.58h-.73v1.22Z",
  fill: "#d9d8d6"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 412,
    height: 114,
    viewBox: "0 0 412 114",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.a44d6ad9.svg";
export { ForwardRef as ReactComponent };